// extracted by mini-css-extract-plugin
export const hide = "facebook-feed-module--hide--2Hx66";